import { Injectable } from '@angular/core';
import { UntypedFormBuilder, ValidatorFn, AbstractControlOptions, AsyncValidatorFn } from '@angular/forms';
import { BitfFormControl } from './bitf-form-control';

@Injectable({
  providedIn: 'root',
})
export class BitfFormBuilderService extends UntypedFormBuilder {
  control(
    formState: any,
    validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
    asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null
  ): BitfFormControl {
    return new BitfFormControl(formState, validatorOrOpts, asyncValidator);
  }
}
